var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.notifications, function (notification, index) {
      return _c(
        "div",
        {
          key: notification.id,
          staticClass: "toast-overflow",
          style: { bottom: _vm.getNotificationPosition(index) },
        },
        [_c("toast", { attrs: { notification: notification } })],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }